/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ComboBox from "../../../components/ComboBox"
import { RootState } from "../../../globalStore/rootreducer"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import dateUtil from "../../../ts/util/dateUtil"
import {
  TSyaryoKeihiGetListReq,
  TSyaryoKeihiGetListRes,
} from "../../../service/budget/syaryoKeihi/TSyaryoKeihi"
import SyaryoKeihiService from "../../../service/budget/syaryoKeihi/SyaryoKeihiService"

/**
 * 車輌経費一覧
 * @returns
 */
const SyaryoKeihiList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)
  const 営業年月 = dayjs(eigyobi).format("YYYY/MM/01")

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "SyaryoKeihiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TSyaryoKeihiGetListRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyaryoKeihiGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition: TSyaryoKeihiGetListReq

    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    setPrevSearchCondition(currentSearchCondition)

    try {
      const res = await new SyaryoKeihiService().getList(currentSearchCondition)
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query = queryString.parse(location.search) as TSyaryoKeihiGetListReq
    set年月From(query.年月From ?? 営業年月)
    set年月To(query.年月To ?? 営業年月)
    set車輌経費区分コード(query.車輌経費区分コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyaryoKeihiGetListReq => {
    return {
      年月From: dateUtil.format(年月From, "YYYY/MM/01") ?? "",
      年月To: dateUtil.format(年月To, "YYYY/MM/01") ?? "",
      車輌経費区分コード: 車輌経費区分コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyaryoKeihiGetListReq
  ) => {
    return {
      年月From: dateUtil.format(searchCondition.年月From, "YYYY/MM") ?? "",
      年月To: dateUtil.format(searchCondition.年月To, "YYYY/MM") ?? "",
      車輌経費区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.車輌経費区分コード &&
          i.分類コード === 区分分類コード.受注配車_請求支払.車輌経費区分
      )?.名称1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // 前回検索条件をクリア
    setPrevSearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月From(営業年月)
    set年月To(営業年月)
    set車輌経費区分コード("")
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // 固定行ヘッダの設定
    for (let r = 0; r < f.rows.length; r++) {
      f.rowHeaders.setCellData(r, 0, r + 1)
    }

    if (e.panel === f.cells) {
    }

    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //grid内エラー項目格納Array
  // const [errorCellPositionList] = useState<
  //   Array<{ 行ID: symbol; colBinding: string }>
  // >([])

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]
  const [車輌経費区分コード, set車輌経費区分コード] = useState<string | null>(
    ""
  )
  const [年月From, set年月From] = useState<string | null | undefined>(営業年月)
  const [年月To, set年月To] = useState<string | null | undefined>(営業年月)

  // ComboBoxState
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [車輌経費区分ComboBox, set車輌経費区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [車輌経費区分IsLoadEnded, set車輌経費区分IsLoadEnded] =
    useState<boolean>(false)

  const [, setPrevSearchCondition] = useState<TSyaryoKeihiGetListReq>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `車輌経費一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())

    new KubunService()
      .getList({
        分類コード: 区分分類コード.受注配車_請求支払.車輌経費区分,
      })
      .then((区分マスタRes) => set区分ItemSource(区分マスタRes.data))
  }, [])

  useEffect(() => {
    if (!車輌経費区分IsLoadEnded) return

    setComboDataInitialized(true)
  }, [車輌経費区分IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車輌経費一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-65rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-10rem">
                              <MonthInput
                                id="年月From"
                                value={年月From}
                                setValue={set年月From}
                                isRequired={true}
                                placeholder="年月From"
                                autoFocus={true}
                              />
                            </div>
                            <div className="w-10rem">
                              <MonthInput
                                id="年月To"
                                value={年月To}
                                setValue={set年月To}
                                isRequired={true}
                                placeholder="年月To"
                              />
                            </div>
                            <div className="w-18rem">
                              <ComboBox.Kubun
                                placeholder="車輌経費区分"
                                分類コード={
                                  区分分類コード.受注配車_請求支払.車輌経費区分
                                }
                                isAllSelect={true}
                                isRequired={false}
                                itemsSource={区分ItemSource}
                                isLoadEnded={車輌経費区分IsLoadEnded}
                                setIsLoadEnded={set車輌経費区分IsLoadEnded}
                                selectedValue={車輌経費区分コード}
                                setSelectedValue={(v) => {
                                  set車輌経費区分コード(v ?? "")
                                }}
                                ComboBox={車輌経費区分ComboBox}
                                setComboBox={
                                  set車輌経費区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <Button
                              type="submit"
                              className="ms-auto"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={true}
                gridProperties={{
                  allowAddNew: false,
                  itemFormatter: (
                    panel: wjcGrid.GridPanel,
                    r: number,
                    c: number,
                    cell: HTMLElement
                  ) => {
                    if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
                      cell.style.textAlign = "center"
                    }
                  },
                }}>
                <wjrGrid.FlexGridColumn
                  binding="年月"
                  width={120}
                  header="年月"
                  cssClass="align-left">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyaryoKeihiGetListRes>
                    ) => {
                      return dateUtil.format(context.item.年月, "YYYY/MM")
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌経費区分名称1"
                  width={160}
                  header="車輌経費区分"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="登録番号HST"
                  width={250}
                  header="登録番号"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額"
                  width={150}
                  header="金額"
                  cssClass="align-end"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SyaryoKeihiList
